module.exports = __webpack_public_path__ + "img/waistline pocket position.bac9f6dd.png";